import { Directive, effect, inject, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import type { Icons } from '@pct/icon';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[customMatSvgIcon]mat-icon',
})
export class CustomMatSvgIconDirective {
  readonly #matIconComponent = inject(MatIcon, { host: true, self: true });
  readonly customMatSvgIcon = input.required<Icons>();

  constructor() {
    effect(() => {
      this.#matIconComponent.svgIcon = this.customMatSvgIcon();
    });
  }
}
